//RSA公钥
export const RSA_PUB_KEY = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAITgphNRVybYtWDguvNrWrj2/XLNzkzfJAz6wP8ZMwbVFtaQT8FPWaPeb1U/mX5pbmufqeyDaoTXedlmEDZbvZ0CAwEAAQ==';

//登录加密
export function crytoLogin(loginData) {
    const encrypt = new window.JSEncrypt();
    encrypt.setPublicKey('-----BEGIN PUBLIC KEY-----' + RSA_PUB_KEY + '-----END PUBLIC KEY-----');
    const rsaData = encrypt.encrypt(loginData);
    // const aesData = CryptoJS.AES.encrypt(JSON.stringify(loginData), CryptoJS.enc.Utf8.parse(AES_KEY), {
    //     mode: CryptoJS.mode.ECB,
    //     padding: CryptoJS.pad.Pkcs7
    // }).toString();
    return {
        rsaData,
        // data: aesData
    }
}
import Vue from "vue";

// 手机号码脱敏
Vue.filter('replacestar', function (value) {
  if (!value) return '';
  let str = value;
     str = str.replace(new RegExp("[^0-9]+","g"),"")
   if(str.length==11){
        str = str.toString().replace(/(\d{2})\d*(\d{2})/ , '$1*******$2')
   }else {
      str = str.toString().replace(/(\d{2})\d*(\d{2})/ , '$1*********$2')
  }
  return str;
})
// 电子邮箱脱敏
Vue.filter('emailStar', function (value) {
  if (!value) return '';
  let str = value;
  str = str.substring(0, 3) + '****' + str.substring(9);
  return str;
})

// 时间戳
Vue.filter("formatDate", function(time) {
        let date = new Date(time);//如果date为13位不需要乘1000
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        let D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
        let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        let m = (date.getMinutes() <10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        let s = (date.getSeconds() <10 ? '0' + date.getSeconds() : date.getSeconds());
        return Y+M+D+h+m+s;
}) 